module.exports = __webpack_public_path__ + "img/shape-3_gray-500.2c5f4e9.png";